import React from "react";
import PropTypes from "prop-types";
import ConnectedRoleCard from "./ConnectedRoleCard";
import TeamRoleCardTitle from "./RoleCardTitle/TeamRoleCardTitle";
import ConnectedSelectedTeamRoleCardExtraTitle from "./ConnectedSelectedTeamRoleCardExtraTitle";

const SelectedTeamRoleCard = ({
    description = "",
    isSelected = false,
    ...props
}) => {
    const renderTitle = (title) => (
        <TeamRoleCardTitle
            description={description}
            title={title}
            isSelected={isSelected}
        />
    );
    const renderSelectedExtraTitle = () => (
        <ConnectedSelectedTeamRoleCardExtraTitle />
    );
    const roleCardProps = {
        ...props,
        renderTitle,
        renderSelectedExtraTitle,
    };
    return <ConnectedRoleCard {...roleCardProps} />;
};

SelectedTeamRoleCard.propTypes = {
    description: PropTypes.string,
    id: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default SelectedTeamRoleCard;
